/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { EmailHandle } from "./EmailHandle";
import {
  EmailHandleFromJSON,
  EmailHandleFromJSONTyped,
  EmailHandleToJSON,
  EmailHandleToJSONTyped,
} from "./EmailHandle";

/**
 * Lean row for the carrier Timeline tab --- the full snapshot is fetched per-email on demand. \[ourParticipants\], \[attachmentCount\], and \[attachmentFilenames\] are derived from the stored thread snapshot so the folded timeline row can show who on our side was involved and how many messages / attachments the thread holds, without fetching the whole conversation.
 * @export
 * @interface CarrierEmailSummary
 */
export interface CarrierEmailSummary {
  /**
   *
   * @type {string}
   * @memberof CarrierEmailSummary
   */
  carrierEmailId: string;
  /**
   *
   * @type {string}
   * @memberof CarrierEmailSummary
   */
  subject?: string | null;
  /**
   *
   * @type {string}
   * @memberof CarrierEmailSummary
   */
  fromHandle?: string | null;
  /**
   *
   * @type {string}
   * @memberof CarrierEmailSummary
   */
  fromName?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CarrierEmailSummary
   */
  sentAt?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof CarrierEmailSummary
   */
  preview?: string | null;
  /**
   *
   * @type {number}
   * @memberof CarrierEmailSummary
   */
  messageCount?: number | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CarrierEmailSummary
   */
  createdAt?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof CarrierEmailSummary
   */
  createdBy?: string | null;
  /**
   *
   * @type {Array<EmailHandle>}
   * @memberof CarrierEmailSummary
   */
  ourParticipants?: Array<EmailHandle> | null;
  /**
   *
   * @type {number}
   * @memberof CarrierEmailSummary
   */
  attachmentCount?: number | null;
  /**
   *
   * @type {Array<string>}
   * @memberof CarrierEmailSummary
   */
  attachmentFilenames?: Array<string> | null;
}

/**
 * Check if a given object implements the CarrierEmailSummary interface.
 */
export function instanceOfCarrierEmailSummary(
  value: object,
): value is CarrierEmailSummary {
  if (!("carrierEmailId" in value) || value["carrierEmailId"] === undefined)
    return false;
  return true;
}

export function CarrierEmailSummaryFromJSON(json: any): CarrierEmailSummary {
  return CarrierEmailSummaryFromJSONTyped(json, false);
}

export function CarrierEmailSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierEmailSummary {
  if (json == null) {
    return json;
  }
  return {
    carrierEmailId: json["carrierEmailId"],
    subject: json["subject"] == null ? undefined : json["subject"],
    fromHandle: json["fromHandle"] == null ? undefined : json["fromHandle"],
    fromName: json["fromName"] == null ? undefined : json["fromName"],
    sentAt: json["sentAt"] == null ? undefined : json["sentAt"],
    preview: json["preview"] == null ? undefined : json["preview"],
    messageCount:
      json["messageCount"] == null ? undefined : json["messageCount"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
    ourParticipants:
      json["ourParticipants"] == null
        ? undefined
        : (json["ourParticipants"] as Array<any>).map(EmailHandleFromJSON),
    attachmentCount:
      json["attachmentCount"] == null ? undefined : json["attachmentCount"],
    attachmentFilenames:
      json["attachmentFilenames"] == null
        ? undefined
        : json["attachmentFilenames"],
  };
}

export function CarrierEmailSummaryToJSON(json: any): CarrierEmailSummary {
  return CarrierEmailSummaryToJSONTyped(json, false);
}

export function CarrierEmailSummaryToJSONTyped(
  value?: CarrierEmailSummary | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierEmailId: value["carrierEmailId"],
    subject: value["subject"],
    fromHandle: value["fromHandle"],
    fromName: value["fromName"],
    sentAt: value["sentAt"],
    preview: value["preview"],
    messageCount: value["messageCount"],
    createdAt: value["createdAt"],
    createdBy: value["createdBy"],
    ourParticipants:
      value["ourParticipants"] == null
        ? undefined
        : (value["ourParticipants"] as Array<any>).map(EmailHandleToJSON),
    attachmentCount: value["attachmentCount"],
    attachmentFilenames: value["attachmentFilenames"],
  };
}
